import { render } from "./Tables.vue?vue&type=template&id=2651841a"
import script from "./Tables.vue?vue&type=script&lang=js"
export * from "./Tables.vue?vue&type=script&lang=js"
script.render = render

export default script